import { createSelector } from 'reselect';
import { NOTIFICATIONS_REDUCER_NAME } from './constants';
import { initialState } from './reducer';
var modalStorageSelector = function (store) {
    return store[NOTIFICATIONS_REDUCER_NAME] || initialState;
};
export var modalStackSelector = createSelector([modalStorageSelector], function (_a) {
    var modals = _a.modals;
    return modals;
});
